import React from 'react';

const SearchIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="490"
    height="490"
    viewBox="0 0 18 18">
    <path fill="#96A7B0" fillRule="evenodd" d="M7.303 0C3.277 0 0 3.277 0 7.303c0 4.027 3.277 7.304 7.303 7.304 1.47 0 2.877-.443 4.078-1.257l.222-.157.332-.243L16.984 18 18 16.984l-5.05-5.05.243-.33c.913-1.248 1.414-2.738 1.414-4.3C14.607 3.276 11.33 0 7.303 0zm0 1.437c3.236 0 5.867 2.631 5.867 5.866 0 3.236-2.631 5.867-5.867 5.867-3.235 0-5.866-2.631-5.866-5.867 0-3.235 2.63-5.866 5.866-5.866z"/>
  </svg>
);

export default SearchIcon;
